import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2172">
      <About data-id="element-2173" />
    </main>;
}